import type { SelectField } from "@payloadcms/plugin-form-builder/types";
import type { Control, FieldErrorsImpl } from "react-hook-form";

import {
  Select as SelectComponent,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@onclicks/sharedcomponents/ui/Select";
import { cn } from "@/utilities/ui";
import React from "react";
import { Controller } from "react-hook-form";

import { FieldError } from "./FieldError";
import { FieldLabel } from "./FieldLabel";
import { fieldClassName } from "./fieldStyles";

export const Select: React.FC<
  SelectField & {
    control: Control;
    errors: Partial<FieldErrorsImpl>;
  }
> = ({ name, control, errors, label, options, required, defaultValue }) => {
  return (
    <div className="flex flex-col gap-2">
      <FieldLabel htmlFor={name} label={label} required={required} />
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={({ field: { onChange, value } }) => {
          const controlledValue = options.find((t) => t.value === value);

          return (
            <SelectComponent
              // Radix émet un "" parasite au montage (select natif caché sans options encore),
              // ce qui écraserait une valeur posée par setValue (ex. query param). Aucun item ne peut valoir "".
              onValueChange={(val) => val && onChange(val)}
              value={controlledValue?.value}
            >
              <SelectTrigger
                id={name}
                aria-invalid={!!errors[name]}
                className={cn(fieldClassName, "w-full data-placeholder:text-black/40")}
              >
                <SelectValue placeholder={label} />
              </SelectTrigger>
              <SelectContent className="rounded border-[#AFB1AB]">
                {options.map(({ label, value }) => (
                  <SelectItem key={value} value={value}>
                    {label}
                  </SelectItem>
                ))}
              </SelectContent>
            </SelectComponent>
          );
        }}
        rules={{ required }}
      />
      {errors[name] && <FieldError name={name} />}
    </div>
  );
};
